import type { FC } from 'react'
import type { CardMeta } from '../dashboard/types'
import CardInfoButton from './CardInfoButton'

type CargoOperationsProps = {
  cargoOps: any[]
  activeCargoOps: number
  tankCargoCount: number
  holdCargoCount: number
  onViewAll: () => void
}

const meta: CardMeta = {
  description: 'Saved cargo records in the selected vessel scope; not an active-status count.',
  endpoint: 'GET /cargo-operations (all pages)',
  logic: 'Counts all fetched pages within the same accessible-vessel filter. TANK/HOLD counts use recorded breakupType.',
}

const CargoOperations: FC<CargoOperationsProps> = ({ cargoOps, activeCargoOps, tankCargoCount, holdCargoCount, onViewAll }) => (
  <div className='flex flex-col flex-1'>
    <div className='card flex-1' style={{ borderRadius: '16px' }}>
      <div className='card-body'>
        <div className='d-flex align-items-center gap-2 mb-3'>
          <h6 className='fw-bold text-dark mb-0' style={{ fontSize: '13px' }}>Cargo Operations</h6>
          <span className='ms-auto d-flex align-items-center gap-2'>
            <CardInfoButton meta={meta} />
            <a href='#' className='fw-bold' style={{ fontSize: '10px' }} onClick={(e) => { e.preventDefault(); onViewAll(); }}>View all</a>
          </span>
        </div>
        <div className='d-flex align-items-center gap-3 mb-3'>
          <div className='text-center'>
            <div className='fw-bold text-dark fs-4'>{activeCargoOps}</div>
            <div className='text-muted' style={{ fontSize: '9px' }}>Saved Records</div>
          </div>
          <div className='flex-1'>
            <div className='d-flex align-items-center gap-2 mb-1'>
              <span className='rounded-circle bg-primary' style={{ width: 8, height: 8 }}></span>
              <span style={{ fontSize: '10px' }}>TANK ({tankCargoCount})</span>
            </div>
            <div className='d-flex align-items-center gap-2'>
              <span className='rounded-circle bg-success' style={{ width: 8, height: 8 }}></span>
              <span style={{ fontSize: '10px' }}>HOLD ({holdCargoCount})</span>
            </div>
          </div>
        </div>
        {cargoOps.length > 0 ? (
          <div className='d-flex flex-column gap-2' style={{ fontSize: '10px' }}>
            {cargoOps.slice(0, 4).map((c: any, i: number) => (
              <div key={i} className='d-flex justify-content-between p-2 rounded' style={{ background: '#f8f9fa' }}>
                <div>
                  <div className='fw-semibold text-dark'>{c.vesselName || '—'}</div>
                  <div className='text-muted'>{c.voyageNumber || '—'} · {c.breakupType}</div>
                </div>
                <div className='text-end'>
                  <div className='fw-semibold text-dark'>{c.totalCargoQtyMt ? `${Number(c.totalCargoQtyMt).toLocaleString()} MT` : '—'}</div>
                  <div className='text-muted'>{c.loadPorts || c.dischargePorts || '—'}</div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='text-center text-muted py-4' style={{ fontSize: '11px' }}>
            <div className='mb-1'>No cargo operations</div>
            <div style={{ fontSize: '10px' }}>Active cargo ops will appear here</div>
          </div>
        )}
      </div>
    </div>
  </div>
)

export default CargoOperations
